import { useState, useEffect, useCallback } from 'react'

import { validTabs } from '../Static/constants'

function useTabNavigation() {
  const [activeTab, setActiveTab] = useState(validTabs.eligibleModels)

  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    const isHashValid = Object.values(validTabs).includes(hash)
    if (hash && isHashValid) {
      setActiveTab(hash)
    }
  }, [])

  const handleTabChange = useCallback((tabId) => {
    setActiveTab(tabId)
    window.history.pushState(null, '', `#${tabId}`)
  }, [])

  return { activeTab, handleTabChange }
}

export default useTabNavigation
